import React from 'react';
export function CookiesPage() {
  return <div className="min-h-screen bg-white py-12 px-4 sm:px-6 lg:px-8" data-id="element-432">
      <div className="max-w-3xl mx-auto" data-id="element-433">
        <h1 className="text-3xl font-bold text-gray-900 mb-8 text-center" data-id="element-434">
          Política de Cookies
        </h1>

        <div className="space-y-6 text-base text-gray-600 leading-relaxed" data-id="element-435">
          <div className="text-center mb-8" data-id="element-436">
            <h2 className="text-xl font-bold text-gray-900" data-id="element-437">
              Política de Cookies de ClubAhorra, Benefika y TicketMaestro
            </h2>
          </div>

          <section data-id="element-438">
            <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-439">
              1. INTRODUCCIÓN
            </h3>
            <p data-id="element-440">
              En ClubAhorra, Benefika y TicketMaestro, utilizamos cookies y
              tecnologías similares para mejorar la experiencia de navegación en
              nuestros sitios web, analizar el tráfico, personalizar el
              contenido y mostrar anuncios relevantes. A continuación, te
              explicamos qué son las cookies, cómo las usamos y cómo puedes
              gestionarlas.
            </p>
          </section>

          <section data-id="element-441">
            <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-442">
              2. ¿QUÉ SON LAS COOKIES?
            </h3>
            <p data-id="element-443">
              Las cookies son pequeños archivos de texto que un sitio web
              almacena en tu dispositivo (computadora, celular o tablet) al
              visitarlo. Estas permiten que el sitio "recuerde" tus acciones o
              preferencias (como idioma, inicio de sesión, etc.) durante un
              período de tiempo determinado.
            </p>
          </section>

          <section data-id="element-444">
            <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-445">
              3. ¿QUÉ TIPOS DE COOKIES UTILIZAMOS?
            </h3>

            <div className="space-y-4 mt-4" data-id="element-446">
              <div data-id="element-447">
                <p className="font-semibold text-gray-800 mb-1" data-id="element-448">
                  A. Cookies necesarias (técnicas):
                </p>
                <p data-id="element-449">
                  Permiten la navegación en el sitio web y el uso de sus
                  funciones esenciales. Sin estas cookies, el sitio no puede
                  funcionar correctamente.
                </p>
              </div>

              <div data-id="element-450">
                <p className="font-semibold text-gray-800 mb-1" data-id="element-451">
                  B. Cookies de preferencia o personalización:
                </p>
                <p data-id="element-452">
                  Almacenan información para que el usuario acceda al servicio
                  con características personalizadas, como el idioma o región.
                </p>
              </div>

              <div data-id="element-453">
                <p className="font-semibold text-gray-800 mb-1" data-id="element-454">
                  C. Cookies de análisis o rendimiento:
                </p>
                <p data-id="element-455">
                  Nos permiten conocer el comportamiento de los visitantes para
                  mejorar el sitio. Usamos herramientas como Google Analytics u
                  otras similares.
                </p>
              </div>

              <div data-id="element-456">
                <p className="font-semibold text-gray-800 mb-1" data-id="element-457">
                  D. Cookies de publicidad o marketing:
                </p>
                <p data-id="element-458">
                  Recopilan información sobre tus hábitos de navegación para
                  mostrarte anuncios relevantes en nuestros sitios o en otros.
                </p>
              </div>
            </div>
          </section>

          <section data-id="element-459">
            <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-460">
              4. ¿CUÁNTO TIEMPO PERMANECEN ACTIVAS?
            </h3>
            <ul className="list-disc pl-5 space-y-2" data-id="element-461">
              <li data-id="element-462">
                <strong data-id="element-463">Cookies de sesión:</strong> se eliminan al cerrar el
                navegador.
              </li>
              <li data-id="element-464">
                <strong data-id="element-465">Cookies persistentes:</strong> permanecen en tu
                dispositivo hasta que las elimines o expiren.
              </li>
            </ul>
          </section>

          <section data-id="element-466">
            <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-467">
              5. ¿CÓMO PUEDES CONTROLAR LAS COOKIES?
            </h3>
            <p className="mb-4" data-id="element-468">
              Al ingresar por primera vez a nuestro sitio, se te mostrará un
              aviso de cookies. Puedes aceptar todas, rechazarlas o
              configurarlas según tu preferencia.
            </p>
            <p className="mb-3" data-id="element-469">
              Además, puedes modificar la configuración de cookies desde tu
              navegador en cualquier momento:
            </p>
            <ul className="list-disc pl-5 space-y-2" data-id="element-470">
              <li data-id="element-471">
                <strong data-id="element-472">Google Chrome:</strong> Configuración de cookies
              </li>
              <li data-id="element-473">
                <strong data-id="element-474">Mozilla Firefox:</strong> Administrar cookies
              </li>
              <li data-id="element-475">
                <strong data-id="element-476">Safari:</strong> Soporte de Safari
              </li>
              <li data-id="element-477">
                <strong data-id="element-478">Microsoft Edge:</strong> Privacidad y servicios
              </li>
            </ul>
          </section>

          <section data-id="element-479">
            <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-480">
              6. COOKIES DE TERCEROS
            </h3>
            <p className="mb-3" data-id="element-481">
              Algunas cookies pueden ser instaladas por servicios de terceros
              utilizados en nuestro sitio (como redes sociales, plataformas de
              video, servicios de estadísticas, etc.). No tenemos control
              directo sobre ellas. Te recomendamos revisar sus respectivas
              políticas:
            </p>
            <ul className="list-disc pl-5 space-y-2" data-id="element-482">
              <li data-id="element-483">
                <strong data-id="element-484">Google:</strong> Política de privacidad
              </li>
              <li data-id="element-485">
                <strong data-id="element-486">Meta (Facebook / Instagram):</strong> Política de
                cookies
              </li>
            </ul>
          </section>

          <section data-id="element-487">
            <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-488">
              7. CAMBIOS EN ESTA POLÍTICA
            </h3>
            <p data-id="element-489">
              Podemos actualizar esta Política de Cookies en cualquier momento.
              Te notificaremos en nuestro sitio web cuando se hagan cambios
              relevantes.
            </p>
          </section>

          <section data-id="element-490">
            <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-491">
              8. CONTACTO
            </h3>
            <p data-id="element-492">
              Si tienes dudas sobre nuestra política de cookies, puedes
              escribirnos a:{' '}
              <span className="font-medium text-brand-600" data-id="element-493">
                contacto@benefica.net
              </span>
            </p>
          </section>

          <section data-id="element-494">
            <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-495">
              9. VIGENCIA
            </h3>
            <p data-id="element-496">
              La vigencia de estas Políticas es desde el 21 de noviembre de 2025
              y permanecerá vigente hasta que exista una nueva versión que la
              reemplace.
            </p>
          </section>

          <div className="pt-8 mt-8 border-t border-gray-200 text-sm text-gray-500" data-id="element-497">
            Última actualización: 21 de noviembre de 2025
          </div>
        </div>
      </div>
    </div>;
}